import { useHistory } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { useAddCourse } from "@circle-react/components/Courses/useAddCourse";
import { usePunditUserContext } from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers";
import { useCanCreateCourses } from "@circle-react/hooks/courses/useCanCreateCourses";
import type { ButtonProps } from "@circle-react-uikit/Button";
import { Button } from "@circle-react-uikit/Button";

export const CreateCourseButton = ({
  children,
  variant = "primary",
  ...props
}: ButtonProps) => {
  const history = useHistory();
  const addCourse = useAddCourse();
  const { canCreateCourses } = useCanCreateCourses();
  const { currentCommunityMember } = usePunditUserContext();

  const onAddCourseClickHandler = () => {
    if (canCreateCourses) {
      addCourse();
    } else {
      history.push(settingsNavPathV3.plans.general);
    }
  };

  if (!isCommunityAdmin(currentCommunityMember)) {
    return null;
  }

  return (
    <Button
      type="button"
      large
      variant={variant}
      onClick={onAddCourseClickHandler}
      {...props}
    >
      {children
        ? children
        : canCreateCourses
          ? t("courses.create_your_first_course_space")
          : t("courses.upgrade_to_create_your_courses")}
    </Button>
  );
};
